import { actionTypes } from '.'

import {
	layoutModeEnum
} from '../../domain/layout'

const localStorageKey = 'layout'

const initialState = {
	mode: layoutModeEnum.default
}

const reducer = (state = initialState, action) => {
  const localStorageData = JSON.parse(localStorage.getItem(localStorageKey)) || {}
  const loadedState = {
    ...state,
    ...localStorageData
  }
  const newState = {
    value: loadedState
  }

  switch (action.type) {
    case actionTypes.SET_MODE:
			Object.assign(newState, {
				value: {
					...loadedState,
					mode: action.payload
				}
			})

			break

    default:
  }

  localStorage.setItem(localStorageKey, JSON.stringify(newState.value))

  return newState.value
}

export default reducer
